var _g, _rect, _path, _path2, _path3, _path4, _path5, _ellipse, _circle, _circle2, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyPruchase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 216,
    viewBox: "0 0 174 216",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1330_6079)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 179,
    width: 124,
    height: 12,
    fill: "#1B3554"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 15,
    width: 124,
    height: 79,
    fill: "#E0E5EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 15V135H6V62.4366L16.0016 47.0864L26 15Z",
    fill: "#CFD4DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149 15V135H169V62.4366L158.998 47.0864L149 15Z",
    fill: "#CFD4DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 62H169V198C169 200.761 166.761 203 164 203H11C8.23858 203 6 200.761 6 198V62Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 117.548C55 116.848 55.3594 116.197 55.9811 115.876C57.3648 115.161 60.0086 114 62.5778 114C65.146 114 67.7143 115.161 69.0525 115.875C69.6555 116.197 70 116.835 70 117.519V117.519C70 119.129 68.1457 120.185 66.6307 119.639C65.4137 119.201 63.9827 118.846 62.54 118.846C61.0687 118.846 59.5975 119.215 58.3503 119.665C56.8381 120.211 55 119.155 55 117.548V117.548Z",
    fill: "#1B3554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106 117.548C106 116.848 106.359 116.197 106.981 115.876C108.365 115.161 111.009 114 113.578 114C116.146 114 118.714 115.161 120.053 115.875C120.656 116.197 121 116.835 121 117.519V117.519C121 119.129 119.146 120.185 117.631 119.639C116.414 119.201 114.983 118.846 113.54 118.846C112.069 118.846 110.597 119.215 109.35 119.665C107.838 120.211 106 119.155 106 117.548V117.548Z",
    fill: "#1B3554"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 88,
    cy: 138.003,
    rx: 16,
    ry: 7.00303,
    fill: "#1B3554"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.149343,
    cx: 51,
    cy: 77,
    r: 6,
    fill: "#1B3554"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.149343,
    cx: 124,
    cy: 77,
    r: 6,
    fill: "#1B3554"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76.6926V39.5C51 19.3416 67.3416 3 87.5 3C107.658 3 124 19.3416 124 39.5V76.6926",
    stroke: "#5E7085",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1330_6079",
    x: 0.813055,
    y: 154.813,
    width: 172.374,
    height: 60.3739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0935,
    result: "effect1_foregroundBlur_1330_6079"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPruchase);
export default __webpack_public_path__ + "static/media/empty_pruchase.851c0fd56e2fdf711f32372b5b6aa897.svg";
export { ForwardRef as ReactComponent };